import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { GlobalSettingsAdapter } from './GlobalSettingsAdapter.js';

@customElement('bh-page-admin-global-settings-accessibility')
export class BHPageAdminGlobalSettingsAccessibility extends GlobalSettingsAdapter {
  override render() {
    return html`
      <x-flex space="xl">
        <bh-breadcrumb
          .items=${[
            { content: this._translation.translate('settings', 'name'), href: '/admin/settings' },
            { content: this._translation.translate('accessibility'), active: true },
          ]}
          .additionalAction=${html`
            <tr-button-small icon="save" .action=${async () => this._formController.validate()}></tr-button-small>
          `}
        ></bh-breadcrumb>
        <tr-tinymce
          ${this._formController.field('accessibility')}
          placeholder=${this._translation.translate('accessibility')}
        ></tr-tinymce>
      </x-flex>
    `;
  }
}
